//#region src/locales/fr/stage.yaml
var data = {
	"chat": {
		"actions": { "retry": "Réessayer" },
		"message": { "character-name": {
			"core-system": "Système central",
			"you": "Vous"
		} },
		"reasoning": "Raisonnement",
		"sessions": {
			"new": "+ Nouveau",
			"empty": "Pas encore de conversation",
			"cloud-badge": "Synchronisé dans le cloud",
			"new-chat-fallback": "Nouvelle conversation",
			"delete": "Supprimer conversation"
		}
	},
	"render-error": {
		"title": "{renderer} n’a pas pu afficher ce modèle",
		"description": "Le modèle est sélectionné, mais la scène n’a pas pu l’afficher.",
		"report-description": "{renderer} n’a pas pu afficher le modèle sélectionné.\nID du modèle : {modelId}\nErreur : {error}"
	},
	"message": "Dites quelque chose...",
	"send-mode": {
		"title": "Envoyer la clef",
		"enter": "Entrée",
		"ctrl-enter": "Ctrl + Entrée",
		"double-enter": "Double Entrée"
	},
	"speech-output": {
		"mute": "Couper la voix",
		"unmute": "Réactiver la voix"
	},
	"operations": {
		"load-models": "Charger les modèles",
		"load-models-status": {
			"loading": "Chargement",
			"ready": "Prêt"
		}
	},
	"select-a-audio-input": "Sélectionner une entrée audio",
	"select-a-model": "Sélectionner un modèle",
	"select-a-voice": "Choisir une voix",
	"viewers": { "debug-menu": {
		"emotions": "Émotions",
		"emotions-btn": {
			"angry": "😠 En colère",
			"awkward": "😳 Mal à l’aise",
			"happy": "😄 Heureux",
			"neutral": "🙂 Neutre",
			"question": "🤔 Interrogatif",
			"sad": "😫 Triste",
			"surprised": "🤯 Surpris",
			"think": "🤨 Pensif"
		},
		"vrm": {
			"camera": "Caméra",
			"model": { "title": "Modèle" }
		}
	} },
	"profile-switcher": {
		"no-profile": "Aucun profil",
		"no-profiles": "Aucuns profils pour l'instant",
		"save-as-new": "Enregistrer comme Nouveau Profil",
		"new-profile-name": "Nom du profil",
		"manage": "Gérer les Profils"
	},
	"promo-banner": { "items": {
		"signin": {
			"watermark": "Lune",
			"fallbackLabel": "Cadeau de la Lune",
			"title": "Connexion sur 7 jours",
			"eventName": "Connectez-vous pour récupérer de la poussière d’étoiles, des cadres d’avatar et des cadeaux de lancement.",
			"date": "28/03 - 10/04",
			"reward": "Jusqu’à 120 poussières d’étoiles",
			"cta": "Se connecter"
		},
		"build": {
			"watermark": "Version",
			"fallbackLabel": "Bonus de construction",
			"title": "Bonus de boîte de ravitaillement",
			"eventName": "Terminez des tâches de construction pour obtenir des bons bonus et des matériaux doublés.",
			"date": "30/03 - 12/04",
			"reward": "5 bons de ravitaillement + matériaux d’amélioration",
			"cta": "Voir les tâches"
		},
		"spring": {
			"watermark": "Printemps",
			"fallbackLabel": "Tirage de printemps",
			"title": "Capsule Carnaval",
			"eventName": "Participez au tirage au printemps pour débloquer des bulles, des charmes et des meubles à thème.",
			"date": "01/04 - 18/04",
			"reward": "Premier tirage à moitié prix + charme rare",
			"cta": "Tirer au sort Maintenant"
		},
		"coupon": {
			"watermark": "Discussion",
			"title": "Coupon de recharge",
			"eventName": "Terminez des interactions de chat pour récupérer des coupons pour l’extension et les packs vocaux.",
			"date": "02/04 - 20/04",
			"reward": "Économisez 6% sur 30 / Économisez 15% sur 68",
			"cta": "Récupérer le coupon"
		},
		"home": {
			"watermark": "Accueil",
			"fallbackLabel": "Thème de la chambre",
			"title": "Mise à jour du thème de printemps",
			"eventName": "Débloquez des thèmes de fenêtre, bureau et lampe de nuit pour rafraîchir votre chambre.",
			"date": "05/04 - 22/04",
			"reward": "Ticket de tirage de thème gratuit à la connexion",
			"cta": "Voir le thème"
		}
	} },
	"waiting": "En attente",
	"websocket-status": {
		"connected": "Connecté",
		"disconnected": "Aucune connexion",
		"open-settings": "Ouvrir les paramètres de connexion"
	}
};
//#endregion
export { data as default };
